export enum DrawerPosition {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum BottomDrawerSize {
  MID = 'mid',
  LARGE = 'large',
  FULL = 'full',
}

export type DrawerWidthSize = 'auto' | 'fixed';

export type HandlerBottomMargin = 'auto' | 'none';

export type DrawerBackdropBehavior =
  | 'dim' // dimmed backdrop, the page behind does not scroll or receive pointer events
  | 'none' // no dimmed backdrop, the page behind still does not scroll
  | 'none-interactable'; // no dimmed backdrop, the page behind can scroll and receive pointer events
